/** @jsx jsx */
export * from './ProductsPageBase';
export { default } from './ProductsPageBase';
